import { truncateUrl } from '../../utils/formatters';

interface TopPagesProps {
  pages: Array<{ urlPath?: string; url?: string; views: number; avgTime?: number }>;
}

export default function TopPages({ pages }: TopPagesProps) {
  return (
    <div className="card">
      <h3 className="mb-4 text-sm font-semibold text-gray-900">Top Pages</h3>
      <div className="overflow-hidden rounded-lg border border-gray-200">
        <table className="min-w-full divide-y divide-gray-200">
          <thead>
            <tr>
              <th className="table-header">Page</th>
              <th className="table-header text-right">Views</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200">
            {pages.slice(0, 5).map((page, i) => {
              const pagePath = page.urlPath || page.url || '/';
              return (
                <tr key={i} className="hover:bg-gray-50">
                  <td className="table-cell">
                    <span className="font-medium" title={pagePath}>
                      {truncateUrl(pagePath)}
                    </span>
                  </td>
                  <td className="table-cell text-right">{(page.views || 0).toLocaleString()}</td>
                </tr>
              );
            })}
            {pages.length === 0 && (
              <tr>
                <td colSpan={2} className="px-6 py-8 text-center text-sm text-gray-500">
                  No page data available
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
